import { OneOnOneActionItem } from 'screens/oneOnOneRabbit/interfaces/OneOnOneActionItem';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';
import { z } from 'zod';

import { createOneOnOneActionItemApi, getOneOnOneActionItemsApi, updateOneOnOneActionItemApi } from '../api';
import { OneOnOneActionItemCreateOrUpdateI, OneOnOneActionItemType } from '../hooks/dataHook';

export const oneOnOneActionItemsValidator = z.array(OneOnOneActionItem.nullable()).nullable();

export const getOneOnOneActionItems = async ({ masterId, instanceId }: OneOnOneRequestI) => {
  try {
    const res = await getOneOnOneActionItemsApi({ masterId, instanceId });
    const data = oneOnOneActionItemsValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one action items details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const createOneOnOneActionItem = async ({
  masterId,
  instanceId,
  ...rest
}: OneOnOneRequestI & OneOnOneActionItemCreateOrUpdateI) => {
  try {
    const res = await createOneOnOneActionItemApi({ masterId, instanceId, ...rest });
    const data = OneOnOneActionItem.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error creating one on one action item ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const updateOneOnOneActionItem = async ({
  masterId,
  instanceId,
  ...rest
}: OneOnOneRequestI & OneOnOneActionItemType) => {
  try {
    const res = await updateOneOnOneActionItemApi({
      masterId,
      instanceId,
      ...rest,
    });
    const data = OneOnOneActionItem.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error creating one on one action item ', error);
    // throw new Error(generateErrorMessage(error));
  }
};
